export default function ValuesSection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[600px] lg:h-[700px]">
      <div className="relative w-full lg:w-1/2 min-h-[400px] lg:min-h-full overflow-hidden bg-background-100">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20close%20up%20of%20precision%20machined%20metallic%20surfaces%20with%20soft%20diffused%20light%20subtle%20brushed%20texture%20in%20warm%20silver%20and%20cream%20tones%20minimalist%20industrial%20aesthetic%20no%20human%20presence%20no%20product%20branding%20desaturated%20elegant%20composition&width=900&height=800&seq=analitikos-values-01&orientation=portrait"
          alt="Abstract precision-machined metallic surfaces with soft diffused light and brushed texture"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>

        <div className="absolute bottom-0 left-0 p-12">
          <span className="text-xs uppercase tracking-[0.2em] text-white/70 font-medium">
            Values
          </span>
          <div className="mt-6 leading-[1.0]">
            <p className="text-3xl md:text-[32px] font-bold text-white">Technical</p>
            <p className="text-4xl md:text-[48px] font-bold text-white">Excellence</p>
            <p className="text-5xl md:text-[64px] font-bold text-white">Innovation</p>
          </div>
        </div>
      </div>

      <div className="w-full lg:w-1/2 bg-white flex items-center justify-center px-8 md:px-16 py-20 lg:py-0">
        <div className="text-center max-w-md">
          <h3 className="text-3xl md:text-[40px] font-bold text-foreground-900 leading-[1.2]">
            Commitment
            <br />
            to Quality
          </h3>
          <p className="mt-2 text-3xl md:text-[40px] font-bold text-foreground-900 leading-[1.2]">
            Future-Ready
            <br />
            Systems
          </p>

          <p className="mt-12 text-base text-foreground-600 leading-relaxed" style={{ maxWidth: '40ch', marginLeft: 'auto', marginRight: 'auto' }}>
            We emphasize continuous innovation and the systematic improvement of development workflows.
            By adopting up-to-date engineering standards, we ensure every system we deliver is reliable,
            maintainable, and prepared for the demands of tomorrow.
          </p>

          <p className="mt-6 text-base text-foreground-600 leading-relaxed" style={{ maxWidth: '40ch', marginLeft: 'auto', marginRight: 'auto' }}>
            Our team actively explores emerging technologies and evolves internal processes to maintain
            the highest level of technical excellence across all projects.
          </p>
        </div>
      </div>
    </section>
  );
}